module.exports = __webpack_public_path__ + "static/media/logo.a0f4acae.svg";